<template>
  <v-alert
    v-if="lastUnreadInPageMessage"
    type="info"
    icon="mdi-message-alert"
    :style="{ zIndex: 2, marginBottom: 0 }"
    @click.native="clicked"
  >
       <v-row align="center">
        <v-col class="grow" v-html="lastUnreadInPageMessage.text"/>
        <v-col class="shrink">
          <v-btn
            @click.native="markAsRead"
            >OK</v-btn>
        </v-col>
      </v-row>
    </v-alert>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      lastUnreadInPageMessage: 'lastUnreadInPageMessage',
    }),
  },
  methods: {
    ...mapActions([
      'addReadInPageMessage',
    ]),
    clicked(ev) {
      if(ev.target.href) {
        this.markAsRead()
      }
    },
    markAsRead() {
      this.addReadInPageMessage(this.lastUnreadInPageMessage)
    }

  }
}
</script>
